import { useEffect } from "react";
import { AI_MODEL_AUTO, type AiModelChoice } from "../../api/aiApi";
import { useAiModelStore, type AiSurface } from "../../store/aiModel.store";

/** The models this organisation's AI can run on; fetched once per page load and shared by every picker. */
export function useAiModelChoices(): AiModelChoice[] {
  const choices = useAiModelStore((s) => s.choices);
  const loadChoices = useAiModelStore((s) => s.loadChoices);
  useEffect(() => {
    if (choices === null) loadChoices();
  }, [choices, loadChoices]);
  return choices ?? [];
}

/**
 * The model to send for a surface. A remembered choice the server no longer
 * offers (the administrator changed the list) quietly falls back to "auto".
 */
export function useAiModel(surface: AiSurface): [string, (model: string) => void] {
  const stored = useAiModelStore((s) => s.bySurface[surface]) ?? AI_MODEL_AUTO;
  const setModel = useAiModelStore((s) => s.setModel);
  const choices = useAiModelChoices();
  const model = choices.some((c) => c.id === stored) ? stored : AI_MODEL_AUTO;
  return [model, (next: string) => setModel(surface, next)];
}
